import { useEffect, useState } from "react";
import { quotationAPI } from "../../../api/quotationAPI";
import { toast } from "react-toastify";

export default function Measurements({ pCode, quotationNo }) {
    const [itemCode, setItemCode] = useState('');
    const [itemName, setItemName] = useState('');
    const [height, setHeight] = useState('');
    const [width, setWidth] = useState('');
    const [area, setArea] = useState('');
    const [remarks, setRemarks] = useState('');
    const [resetKey, setResetKey] = useState(0);
    const [searchKey, setSearchKey] = useState('');
    const [allItems, setAllItems] = useState([]);

    useEffect(() => {
        const modalElement = document.getElementById("measurementsModal");
        const searchInput = document.getElementById("searchInput");

        const handleModalClose = () => {
            setSearchKey("");
            searchInput.value = "";
            handleClear();
        };

        if (modalElement) {
            modalElement.addEventListener("hidden.bs.modal", handleModalClose);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener("hidden.bs.modal", handleModalClose);
            }
        };
    }, []);


    const getAllQuotationItems = () => {
        quotationAPI.getAllQuotationItems(searchKey, pCode, quotationNo).then((data) => {
            setAllItems(data);
        });
    };

    const handleRowClick = (code, name, price) => {
        setItemCode(code);
        setItemName(name);
    }

    useEffect(() => {
        if (quotationNo) {
            getAllQuotationItems()
        }
    }, [searchKey, pCode, quotationNo]);

    const handleSaveMeasurements = () => {
        if (!quotationNo) {
            toast.error("Quotation No is required to save measurements.");
            return;
        }


        if (!height || height <= 0) {
            toast.warning("Please enter a valid height greater than zero.");
            return;
        }

        if (!width || width <= 0) {
            toast.warning("Please enter a valid width greater than zero.");
            return;
        }

        if (!area || area <= 0) {
            toast.warning("Please enter a valid area greater than zero.");
            return;
        }

        const measurements = {
            quotationNo,
            pCode,
            itemCode,
            height,
            width,
            area,
            remarks
        }
        quotationAPI.saveMeasurements(measurements).then(() => {
            toast.success("Measurements saved successfully!");
            handleClear();

            // Close the modal
            const modalElement = document.getElementById("measurementsModal");
            // eslint-disable-next-line no-undef
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        })
    }

    const handleClear = () => {
        setResetKey(resetKey + 1);
        setItemCode('');
        setItemName('');
        setHeight('');
        setWidth('');
        setArea('');
        setRemarks('');
    }

    return (
        <div className="modal fade" id="measurementsModal" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add Measurements</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div class="form-group row">
                                <input
                                    id="searchInput"
                                    value={searchKey}
                                    type="text"
                                    className="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 form-control"
                                    placeholder="Search by code or name"
                                    onChange={(e) => setSearchKey(e.target.value)}
                                />
                                <div class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-10 col-xl-10 input_field">
                                </div>
                                <div class="col-2 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 form-check">
                                </div>
                            </div>

                            <div class=" table-container form-group row">
                                <table className="table mt-1">
                                    <thead className="thead--color">
                                        <tr>
                                            <th scope="col">Item Code</th>
                                            <th scope="col">Description</th>
                                            <th scope="col">Sell Price</th>
                                            <th className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allItems.map((data, index) => (
                                            <tr key={index}>
                                                <td>{data.itemCode}</td>
                                                <td>{data.itemName}</td>
                                                <td>{Number(data.sellPrice).toFixed(2)}</td>
                                                <td className="text-center"><button type="button" className="btn btn-sm btn-dark"
                                                    onClick={() => handleRowClick(data.itemCode, data.itemName, data.sellPrice)}>
                                                    Select</button></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-10 col-xl-10 input_field">
                                </div>
                                <div class="col-2 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 form-check">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="staticEmail"
                                    class="col-12 col-xs-12 col-sm-3 col-md-12 col-lg-3 col-xl-3 col-form-label">
                                    Item
                                </label>
                                <div class="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 input_field">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="inputPassword"
                                        value={itemCode}
                                        onChange={(e) => setItemCode(e.target.value)}
                                        disabled
                                    />
                                </div>

                                <div
                                    class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-6 col-xl-6 form-check">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={itemName}
                                        onChange={(e) => setItemName(e.target.value)}
                                        disabled
                                    />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="staticEmail"
                                    class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">Height</label>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 input_field">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={height}
                                        onChange={(e) => setHeight(e.target.value)}
                                    />
                                </div>
                                <label for="staticEmail"
                                    class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">Width</label>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 input_field">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={width}
                                        onChange={(e) => setWidth(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="staticEmail"
                                    class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">Area</label>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-9 col-xl-9 input_field">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={area}
                                        onChange={(e) => setArea(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="staticEmail"
                                    class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">Remarks</label>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-9 col-xl-9 input_field">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                                    <button type="button" className="btn btn-dark form-control mt-1" onClick={handleSaveMeasurements}>Save</button>
                                </div>
                                <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                                    <button type="button" className="btn btn-dark form-control mt-1" onClick={handleClear}>Clear</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}